import {
  getAuth,
  signInWithEmailAndPassword,
  signInWithPopup,
  signInWithPhoneNumber,
  GoogleAuthProvider,
  FacebookAuthProvider,
  TwitterAuthProvider,
  RecaptchaVerifier,
} from "firebase/auth";
import { signInMethodTypes } from "../../../cnr/reducers/SignInReducer";

export const firebaseAuth = async (
  appSignIn,
  methods,
  ignoreEmailLine,
  linkOnly,
  callback
) => {
  const auth = getAuth();
  const {
    useRecaptcha,
    allowEmailLink,
    allowEmail,
    allowFacebook,
    allowGoogle,
    allowPhone,
    allowTwitter,
  } = appSignIn ?? {};

  // Build list of enabled sign-in methods
  const enabledMethods = methods?.length
    ? methods
    : [
        allowEmail && signInMethodTypes.emailAndPassword,
        allowFacebook && signInMethodTypes.facebook,
        allowGoogle && signInMethodTypes.google,
        allowPhone && signInMethodTypes.phone,
        allowTwitter && signInMethodTypes.twitter,
      ].filter(Boolean);

  // Create provider instances
  const providers = {
    [signInMethodTypes.google]: new GoogleAuthProvider(),
    [signInMethodTypes.facebook]: new FacebookAuthProvider(),
    [signInMethodTypes.twitter]: new TwitterAuthProvider(),
  };

  // ✅ Email/password sign-in
  const emailSignIn = async (email, password) => {
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      callback?.(result);
      return result;
    } catch (err) {
      console.error("Email sign-in error:", err);
      throw err;
    }
  };

  // ✅ Popup-based sign-in (Google, Facebook, Twitter)
  const popupSignIn = async (type) => {
    try {
      const provider = providers[type];
      if (!provider) throw new Error(`Provider not configured: ${type}`);
      const result = await signInWithPopup(auth, provider);
      callback?.(result);
      return result;
    } catch (err) {
      console.error(`${type} sign-in error:`, err);
      throw err;
    }
  };

  // ✅ Phone sign-in
  const phoneSignIn = async (phoneNumber, appVerifierId = "recaptcha-container") => {
    try {
      const appVerifier = new RecaptchaVerifier(appVerifierId, {
        size: useRecaptcha ? "normal" : "invisible",
      }, auth);
      const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
      return confirmationResult; // You’ll still need to handle user entering the SMS code
    } catch (err) {
      console.error("Phone sign-in error:", err);
      throw err;
    }
  };

  // 🚀 Return an object of methods you can call from your UI
  return {
    emailSignIn,
    popupSignIn,
    phoneSignIn,
    enabledMethods, // for rendering UI buttons conditionally
  };
};


// import { getAuth, EmailAuthProvider, FacebookAuthProvider, GoogleAuthProvider, PhoneAuthProvider, TwitterAuthProvider } from "firebase/auth";
// import * as firebaseui from "firebaseui";
// import { signInMethodTypes } from "../../../cnr/reducers/SignInReducer";
 
// export const firebaseAuth = (appSignIn, methods, ignoreEmailLine, linkOnly, callback) => {

//   const { useRecaptcha, allowEmailLink, allowEmail, allowFacebook, allowGoogle, allowPhone, allowTwitter } = appSignIn ?? {}

//   // const hmmm = () => {
//   //   const pwd = document.getElementById('ui-sign-in-password-input')
//   // }

//   const addMethod = (m) => {
//     switch (m) {
//       case signInMethodTypes.emailAndPassword:
//         return {
//           provider: EmailAuthProvider.PROVIDER_ID,
//           signInMethod: (allowEmailLink || linkOnly) && !ignoreEmailLine ? EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD : EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD,
//           appName: 'meetingEvolution'
//         }
//       case signInMethodTypes.facebook:
//         return {
//           provider: FacebookAuthProvider.PROVIDER_ID,
//         }
//       case signInMethodTypes.google:
//         return {
//           provider: GoogleAuthProvider.PROVIDER_ID,
//         }
//       case signInMethodTypes.phone:
//         return {
//           provider: PhoneAuthProvider.PROVIDER_ID,
//           recaptchaParameters: { size: !useRecaptcha ? 'invisible' : 'normal', badge: 'inline' }
//         }
//       case signInMethodTypes.twitter:
//         return {
//           provider: TwitterAuthProvider.PROVIDER_ID,
//         }
//       default:
//         break;
//     }
//   }

//   const getSignInOptions = () => {
//     const items = []
//     if (methods) {
//       methods.forEach(m => {
//         items.push(addMethod(m))
//       })
//     } else {
//       if (allowEmail) { items.push(addMethod(signInMethodTypes.emailAndPassword)) }
//       if (allowFacebook) { items.push(addMethod(signInMethodTypes.facebook)) }
//       if (allowGoogle) { items.push(addMethod(signInMethodTypes.google)) }
//       if (allowPhone) { items.push(addMethod(signInMethodTypes.phone)) }
//       if (allowTwitter) { items.push(addMethod(signInMethodTypes.twitter)) }
//     }
//     return items
//   }

//   const uiConfig = {
//     signInOptions: getSignInOptions(),
//     callbacks: {
//       signInSuccessWithAuthResult: function (authResult) {
//         console.log('authResult', authResult)
//       },
//       uiShown: function () {
//         // The widget is rendered.
//         // Hide the loader. 
//         // hmmm()
//         // document.getElementById('loader').style.display = 'none';
//       },
//     },
//   };
//   const auth = getAuth()
//   var ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
//   ui.start("#firebaseui-auth-container", uiConfig);
// }
